module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UnitForward", "Forward device information to customer") ))==null?'':__t)+
'</legend><div><label for="forward-email-input">'+
((__t=( i18n.tc("UnitForward", "Customer Email:") ))==null?'':__t)+
'</label> <input type="text" id="forward-email-input" data-input="forward-email"></div></fieldset><fieldset class="button-wrap"><button data-click="forward-cancel">'+
((__t=( i18n.tc("UnitForward", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="forward-submit">'+
((__t=( i18n.tc("UnitForward", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
